import React, { FC } from 'react';
import {
    GetAllLofasFiltered_getAllLofasFiltered as Lofa,
    GetAllRegions_getAllRegions as RegionType
} from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import { Option } from './interface';
import LofaItem from './LofaItem';
import './Lofas.scss';

interface LofaListProps {
    lofas: Lofa[];
    regionsWithDistricts: RegionType[];
    canEditLofas: boolean;
    isLoading: boolean;
    isEndOfResults: boolean;
    onEditClick: (Lofa: Lofa) => void;
    onLoadMore: () => void;
    onDelete?: (record: any) => void;
    onCLickLofa: (lat: number, lng: number, lofaName: string) => void;
}

const LofaList: FC<LofaListProps> = ({
    lofas,
    regionsWithDistricts,
    isLoading,
    isEndOfResults,
    onEditClick,
    canEditLofas,
    onLoadMore,
    onDelete,
    onCLickLofa,
}: LofaListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('lofaList', isLoading, isEndOfResults, onLoadMore);

    return (
        <div className="Lofas-List" onScroll={handleScroll}>
            {
                lofas.map((lofa, index) => (
                    <LofaItem
                        key={lofa.id ? lofa.id.toString() : '0'}
                        index={index}
                        canEditLofas={canEditLofas}
                        onEditClick={onEditClick}
                        lofa={lofa}
                        regionsWithDistricts={regionsWithDistricts}
                        onDelete={onDelete}
                        onCLickLofa={onCLickLofa}
                    />
                ))
            }
        </div>
    );
};

export default LofaList;

